<div [ngClass]="validateStyle()">
    <mat-icon matTooltipPosition="above" [matTooltip]="textTooltip">{{icon || 'add'}}</mat-icon>
    <div class="contentText">
        <div *ngIf="isInfo == true">{{text || 'Sin Data'}}</div>
        <div *ngIf="isInfo == false" class="title">{{text || 'Sin Data'}}</div>
        <div *ngIf="isInfo == false" class="sub-title" >{{subText || 'No hay informacion'}}</div>
    </div>
</div>
